import Head from "next/head"
import OG from "./OG";

const PageHead = (props) => {
    const {
        title = false,
        description = false,
        keywords = false,
        link = false,
        ogTitle = false,
        ogType = false,
        ogUrl = false,
        ogImage = false,
        ogDescription = false,
        ogSiteName = false
    } = props;

    return (
        <Head>
            {title && <title>{title}</title>}
            {description && (
                <meta
                    name="description"
                    content={description}
                />
            )}
            {keywords && <meta name="keywords" content={keywords} />}
            {link && <link rel="canonical" href={link} />}
            {ogTitle && <OG property='title' content={ogTitle} />}
            {ogType && <OG property='type' content={ogType} />}
            {ogUrl && <OG property='url' content={ogUrl} />}
            {ogImage && <OG property='image' content={ogImage} />}
            {ogDescription && <OG property='description' content={ogDescription} />}
            {ogSiteName && <OG property='site_name' content={ogSiteName} />}
        </Head>
    )
}

export default PageHead